<template>
  <div class="dashboard-space dashboard-background min-vh-100 flex flex-col">
    <dashboard-header />
    <div class="text-center flex flex-col grow lg:justify-center font-[ProximaNova] py-[71px]">
      <div class="flex flex-col items-center">
        <h1 class="text-5xl font-bold mb-3">
          Your Account Has Expired!
        </h1>
        <p class="text-xl text-[#787878] mb-12">
          Please reactivate your account now to avoid the deletion of projects and content.
        </p>
        <!--        <iframe-->
        <!--          v-if="!isBusinessPromoMember"-->
        <!--          src="https://player.estage.com/2Ja84rwwuZzp67pEfLyh"-->
        <!--          frameborder="0"-->
        <!--          class="aspect-video w-full max-w-4xl mx-6 mb-12"-->
        <!--          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; screen-wake-lock"-->
        <!--          allowfullscreen-->
        <!--        />-->

        <button
          class="h-16 w-full max-w-72 mt-[32px] px-[24px] bg-[#4F83E3] hover:opacity-80 text-[18px] text-white rounded"
          @click="modal = true"
        >
          Reactivate My Account Now!
        </button>

        <reactivate-plan-modal
          v-model="modal"
          :success="paymentSuccess"
          @submit="onReactivate"
        />
        
        <!--        <template v-if="isBusinessPromoMember">-->
        <!--          <button-->
        <!--            class="h-16 w-full max-w-72 mt-[32px] px-[24px] bg-[#4F83E3] hover:opacity-80 text-[18px] text-white rounded"-->
        <!--            @click="modal = true"-->
        <!--          >-->
        <!--            Reactivate My Account Now!-->
        <!--          </button>-->

        <!--          <reactivate-plan-modal-->
        <!--            v-model="modal"-->
        <!--            :success="paymentSuccess"-->
        <!--            @submit="onReactivate"-->
        <!--          />-->
        <!--        </template>-->
        <!--        <a-->
        <!--          v-else-->
        <!--          class="h-16 inline-flex items-center justify-center cursor-pointer w-full max-w-72 bg-[#4F83E3] hover:opacity-80 text-lg text-white font-medium rounded"-->
        <!--          style="text-decoration: none"-->
        <!--          href="https://estage.com/ebp-founder-discount"-->
        <!--          target="_blank"-->
        <!--        >-->
        <!--          Reactivate My Account Now!-->
        <!--        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapGetters, mapState} from 'vuex'
import DashboardHeader from '@/layouts/dashboard/DashboardHeader.vue'
import ReactivatePlanModal from '@/components/editor/modals/reactivate-plan/ReactivatePlanModal.vue'

export default {
  name: 'Reactivate',
  components: {
    DashboardHeader,
    ReactivatePlanModal
  },
  data () {
    return {
      modal: false,
      paymentSuccess: false,
      paypalChecking: false,
      checkPPTimout: null,
      communityPlusTag: false,
      planCodes: [
        'BUSINESS_PLUS_M',
        'BUSINESS_PLUS_Y',
        'ESTAGE_SUB',
        'BUSINESS_Y'
      ],
      statuses: {
        payment_failed: {
          reason: 'payment failure',
          video_id: '897472426'
        },
        refund: {
          reason: 'payment refunded',
          video_id: '897473108'
        },
        canceled: {
          reason: 'account cancelation request',
          video_id: '897473962'
        },
        no_subscription: {
          reason: 'subscription not found'
        }
      }
    }
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),
    ...mapGetters('auth', {
      'pendingReactivation': 'pendingReactivation',
      'isLifetime': 'isLifetime'
    }),
    // showTimer () {
    //   return this.user.user_subscription && moment(this.user.user_subscription.data_deleted_at).isAfter(moment())
    // },
    userSubscriptionEmpty () {
      return !this.user.user_subscription && this.user?.projects_count > 0
    },
    isBusinessPromoMember () {
      return this.user.user_subscription && this.user.user_subscription.plan.id === 7 && this.communityPlusTag
    }
    // FpGm12 () {
    //   return this.user.user_subscription.reason === 'fp_gm_12' || this.user.user_subscription.plan.code === 'FP_GOLD'
    // }
  },
  watch: {
    modal (newValue) {
      if(!newValue && this.paymentSuccess) {
        window.location = '/'
      }
    }
  },
  created () {
    axios.post('api/estagesocial/has-tags', {
      email: this.user.email,
      tags: [12738]
    }).then(({data}) => {
      this.communityPlusTag = data.data
    })
  },
  mounted () {
    if (this.checkIsAlreadyReactivated(this.user)) {
      return this.$router.push({name: 'dashboard'})
    }
    this.checkPayPalStatus()
  },
  beforeDestroy () {
    if(this.checkPPTimout) clearTimeout(this.checkPPTimout)
  },
  methods: {
    ...mapActions({
      reactivatePlan: 'subscription/reactivatePlan'
    }),
    checkIsAlreadyReactivated (user) {
      if (this.userSubscriptionEmpty) {
        return false
      } else {
        return !this.pendingReactivation && !(user.user_subscription &&
            (!_.includes(['succeeded', 'succeeeded'], user.user_subscription.status)) || user.status_code === 'refunded' || user.user_subscription.plan.id === 7 || user?.exp_date?.days_overdue >= 7) && !this.isLifetime
      }
    },
    getStatus (key) {
      const reason = this.userSubscriptionEmpty ? 'no_subscription' : this.user.user_subscription.reason
      return _.get(this.statuses[reason], key)
    },
    checkPayPalStatus () {
      const count = localStorage.getItem('pp-attempt-count')
      if(count === null) return
      if(count > 15) {
        localStorage.removeItem('pp-attempt-count')
        this.$swal({
          icon: 'error',
          iconColor: '#4F83E3',
          toast: true,
          position: 'top-right',
          title: 'PayPal Payment Declined.',
          text: 'Please try again later or let us know about your problem.',
          showConfirmButton: false,
          timer: 5000
        })
        this.modal = false
        this.paypalChecking = false
      }
      else {
        this.paypalChecking = true
        axios.get('api/auth/user')
          .then((result) => {
            if (!this.checkIsAlreadyReactivated(result.data)) {
              localStorage.removeItem('pp-attempt-count')
              if(this.checkPPTimout) clearTimeout(this.checkPPTimout)
              this.paypalChecking = false
              this.paymentSuccess = true
            }
            else {
              this.checkPPTimout = setTimeout(() => {
                localStorage.setItem('pp-attempt-count', parseInt(count) + 1)
                this.checkPayPalStatus()
              }, 1000 * 10)
            }
          })
      }
    },
    onPayPalSuccess () {
      localStorage.setItem('pp-attempt-count', 0)
      this.checkPayPalStatus()
    },
    async onReactivate ({payment_method, pm, plan, setLoading}) {
      setLoading(true)
      let payload = {
        body: {
          plan
        }
      }
      if (pm) {
        payload.pm = pm
      } else {
        payload.payment_method = payment_method
      }
      
      await this.reactivatePlan(payload)
        .then(() => {
          this.paymentSuccess = true
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }
}
</script>
<style>
  /* .radio-custom {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 17px;
    width: 17px;
    border: 2px solid #3D82EA;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
  }

  input[type="radio"].radio-custom:checked, input[type="radio"].radio-custom:focus {
    border: 2px solid #3D82EA;
    background-color: #3D82EA;
    box-shadow: inset 0 0 0 3px white!important;
  }
  input[type="radio"][disabled]{
    border: 2px solid #E2E5EC;
    background-color: #E2E5EC;
    box-shadow: inset 0 0 0 3px white!important;
  }
  .pm-custom-select-arrow{
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGlkPSJsaW5lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMzE1NTE2IDAuMTcwODU0QzAuNTI5MTcyIC0wLjA1Njk1MTUgMC44NzU1NzggLTAuMDU2OTUxNSAxLjA4OTIzIDAuMTcwODU0TDUuMDc5MTkgNC40MjUwNEw5LjA2OTE0IDAuMTcwODU0QzkuMjgyOCAtMC4wNTY5NTE1IDkuNjI5MiAtMC4wNTY5NTE1IDkuODQyODYgMC4xNzA4NTRDMTAuMDU2NSAwLjM5ODY2IDEwLjA1NjUgMC43NjgwMDYgOS44NDI4NiAwLjk5NTgxMkw1LjQ2NjA1IDUuNjYyNDhDNS4yNTIzOSA1Ljg5MDI5IDQuOTA1OTggNS44OTAyOSA0LjY5MjMzIDUuNjYyNDhMMC4zMTU1MTYgMC45OTU4MTJDMC4xMDE4NTkgMC43NjgwMDYgMC4xMDE4NTkgMC4zOTg2NiAwLjMxNTUxNiAwLjE3MDg1NFoiIGZpbGw9IiMxRTFFMUUiLz4KPC9zdmc+Cg==')!important;
  }
  .pm-custom-select.v-select.custom-select .vs__selected{
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
  } */
</style>
